// @module ROOM4.CCAProductImageEventOverlay.CCAProductClearancePriceLabel
define("ROOM4.CCAProductImageEventOverlay.CCAProductClearancePriceLabel.View", [
  "room4_ccaproductimageeventoverlay_ccaproductclearancepricelabel.tpl",
  "SCView",
], function (
  room4_ccaproductimageeventoverlay_ccaproductclearancepricelabel_tpl,
  SCViewModule,
) {
  "use strict";

  var SCView = SCViewModule.SCView;

  function ClearancePriceLabelView(config) {
    SCView.call(this, config);
    this.template =
      room4_ccaproductimageeventoverlay_ccaproductclearancepricelabel_tpl;
    this.contextDataRequest = ["item"];
  }

  ClearancePriceLabelView.prototype = Object.create(SCView.prototype);
  ClearancePriceLabelView.prototype.constructor = ClearancePriceLabelView;

  ClearancePriceLabelView.prototype.getContext = function () {
    return {
      clearance: this.contextData.item().custitem6,
    };
  };

  return ClearancePriceLabelView;
});
